import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_CMS_PUBLIC_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default client;
